import React from 'react';

interface ScrudixLogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeMap: Record<NonNullable<ScrudixLogoProps['size']>, string> = {
  sm: 'h-7 w-7',
  md: 'h-8 w-8',
  lg: 'h-10 w-10',
};

const ScrudixLogo: React.FC<ScrudixLogoProps> = ({ size = 'md', className = '' }) => {
  return (
    <img
      src="/scrudix-logo-current.png"
      alt="Scrudix"
      className={`${sizeMap[size]} rounded-lg ${className}`}
      width={size === 'sm' ? 28 : size === 'lg' ? 40 : 32}
      height={size === 'sm' ? 28 : size === 'lg' ? 40 : 32}
    />
  );
};

export default ScrudixLogo;
